import React, { ButtonHTMLAttributes } from 'react';
import classNames from 'classnames';
import style from './Button.module.scss';

type TButtonTypes = 'submit' | 'reset' | 'button';
type TButtonThemes =
	| 'primary'
	| 'primaryBlue'
	| 'secondary'
	| 'secondaryPurple'
	| 'outlined'
	| 'outlinedPurple'
	| 'clear';
type TButtonSizes = 'sizeS' | 'sizeM';
type TButtonIconPositions = 'pre' | 'post';

interface IButton extends ButtonHTMLAttributes<HTMLButtonElement> {
	className?: string;
	theme?: TButtonThemes;
	size?: TButtonSizes;
	disabled?: boolean;
	type?: TButtonTypes;
	wrapText?: boolean;
	icon?: React.ReactNode;
	iconPosition?: TButtonIconPositions;
}

const Button: React.FC<IButton> = ({
	className,
	theme = 'primary',
	size = 'sizeM',
	disabled = false,
	type = 'button',
	wrapText = false,
	icon,
	iconPosition = 'pre',
	onClick,
	children,
	...restProps
}) => {
	const buttonClasses = classNames(
		style.button,
		style[theme],
		style[size],
		{ [style.disabled]: disabled },
		{ [style.textNoWrap]: !wrapText },
		className,
	);

	return (
		<button
			className={buttonClasses}
			disabled={disabled}
			type={type}
			onClick={!disabled ? onClick : undefined}
			{...restProps}>
			{iconPosition === 'pre' && icon}
			<div className={style.text}>{children}</div>
			{iconPosition === 'post' && icon}
		</button>
	);
};

export default React.memo(Button);
